import React, { FC, KeyboardEventHandler } from "react";
import styled from "styled-components";

import { toREM, toVWDesktop, toVWMobile } from "../../helpers/styles";
import { BREAKPOINTS, MEDIA } from "../../helpers/theme";
import SelectMain from "../shared/Select";
import Select from "../shared/Select";
import SearchInput from "../RecipeSearch/TextInput";
import { useMediaQuery } from "@react-hook/media-query";
import { useStaticLabels } from "../../hooks/useStaticLabels";

export type SearchTabsProps = {
  tags: TagType[];
  active: number;
  searchTerm: string;
  searchPlaceholder: string;
  onSearchTermChange: (searchTerm: string) => void;
  setActive: (index: number) => void;
  className?: string;
  onInputKeyPress?: KeyboardEventHandler;
};

export type TagType = {
  label: string;
  value: string;
};

const SearchTags: FC<SearchTabsProps> = ({
  tags,
  searchPlaceholder,
  active,
  setActive,
  searchTerm,
  onSearchTermChange = () => {
    return;
  },
  className,
  onInputKeyPress,
}: SearchTabsProps) => {
  const labels = useStaticLabels();
  const isDesktop = useMediaQuery(MEDIA.DESKTOP);
  const isMobile = useMediaQuery(MEDIA.MOBILE);

  return (
    <Container className={className}>
      {isDesktop && (
        <Select
          selected={active}
          label={labels?.tags}
          aria-label={labels?.tags}
          options={tags}
          onChange={(_, index) => setActive(index)}
        />
      )}

      <SearchInputWrapper>
        <SearchInput
          value={searchTerm}
          label={searchPlaceholder}
          onChange={(v: string) => {
            onSearchTermChange(v);
          }}
          onClose={() => {
            onSearchTermChange("");
          }}
          onKeyPress={onInputKeyPress}
        />
      </SearchInputWrapper>
      {isMobile && (
        <SelectMain
          label={labels?.tags}
          aria-label={labels?.tags}
          options={tags}
          onChange={(_, index) => setActive(index)}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  background-color: #033305;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    flex-direction: row;
    align-items: center;
    margin-bottom: ${toVWDesktop(40)}vw;
  }

  && .tab-container {
    justify-content: flex-start;

    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      display: flex;
      align-items: flex-end;
      gap: ${toVWDesktop(35)}vw;
      padding: ${toVWDesktop(50)}vw ${toVWDesktop(80)}vw;
    }
  }

  && .tab {
    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      font-weight: 800;
      font-size: ${toREM(24)}rem;
      line-height: ${toVWDesktop(5)}vw;
      height: ${toVWDesktop(30)}vw;
    }
  }

  && .container {
    display: none;

    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      display: flex;
    }
  }
`;

const SearchInputWrapper = styled.div`
  margin-bottom: ${toVWMobile(24)}vw;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-top: 0;
    display: flex;
    margin-bottom: 0;
    padding: 0;
    min-width: ${toVWDesktop(400)}vw;
    width: ${toVWDesktop(400)}vw;
  }
`;

export default SearchTags;
